import React from 'react';
import { Text, Stack } from '@moda/om';
import { FINAL_SALE_COPY, FINAL_SALE_TEXT } from '../../../constants';
import { ReturnPolicy } from '../../../generated/types';
import { ReturnPolicyHyperlink } from '../../ReturnPolicyInformation';

import './ProductDetailsFinalSaleInformation.scss';

interface Props {
  returnPolicy: ReturnPolicy | null;
}

export const ProductDetailsFinalSaleInformation: React.FC<Props> = ({ returnPolicy }) => {
  if (!returnPolicy) return null;

  if (returnPolicy !== ReturnPolicy.final_sale) return null;

  return (
    <ReturnPolicyHyperlink className="ProductDetailsFinalSaleInformation">
      <Stack space={0} direction="horizontal">
        <Text treatment="bold1">{FINAL_SALE_TEXT}</Text>
        {FINAL_SALE_COPY}
      </Stack>
    </ReturnPolicyHyperlink>
  );
};
